<roma-mobile-clock-hour-admin
  *ngFor="let item of source"
  [content]="{
    id: item.id,
    img: item.img,
    user: item.user,
    status: item.status,
    title: item.title,
    description: item.description,
    startDate: item.startDate,
    endDate: item.endDate,
    hour: item.hour
  }"
  (actions)="makeActions($event)"
  [showActions]="showActions"
>
</roma-mobile-clock-hour-admin>
